module.exports = __webpack_public_path__ + "static/36-dbbd68fe6294d82c222f5badf0514c55.png";